import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-icon",
  "use": "chevron-icon-usage",
  "viewBox": "0 0 22 12",
  "content": "<symbol viewBox=\"0 0 22 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-icon\">\r\n<path d=\"M1 0.999999L11 11L21 1\" stroke=\"#161D28\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol